import { ICreateJobForm } from '@/Models'
import { useFieldArray, useFormContext } from 'react-hook-form'
import * as yup from 'yup'

export const strReq = 'Field must be a string'
export const bolReq = 'Field must be a boolean'
export const reqField = 'Field is required'

export const createJobStepThreeSchema = yup.object().shape({
  customQuestions: yup.array().of(
    yup.object().shape({
      title: yup.string(),
      type: yup.string(),
      required: yup.boolean().default(false),
    }),
  ),
})
export const CreateJobStepThreeComp = () => {
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext<ICreateJobForm>()

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'customQuestions',
  })

  return (
    <div className='container'>
      <div className='row justify-content-center'>
        <div className='text-start mb-4 card-title p-0'>
          <p>
            Default fields (always collected): Name, Email, Phone, Location, CV/Resume, LinkedIn.
          </p>
          <h4>Custom Questions</h4>
        </div>
        {fields.map((field, index) => (
          <div
            key={field.id}
            className={`form-group step-three row justify-content-center align-items-center row-up ps-2 pe-2 ${index > 0 && 'mt-1'}`}
          >
            <div className='custom-question borde rounded p-3 mb-3'>
              <div className='row'>
                <div className='mb-3 text-start col-md-6'>
                  <label>Field Title</label>
                  <input
                    placeholder='Share a link to your portfolio or GitHub.'
                    type='text'
                    className='form-control'
                    {...register(`customQuestions.${index}.title`)}
                  />
                  {errors.customQuestions?.[index]?.title && (
                    <p className='text-danger'>
                      {' '}
                      {errors.customQuestions?.[index]?.title?.message}{' '}
                    </p>
                  )}
                </div>
                <div className='text-start col-md-6'>
                  <label>Type</label>
                  <select className='form-select' {...register(`customQuestions.${index}.type`)}>
                    <option value=''>Select</option> <option value='shortText'>Short Text</option>
                    <option value='longText'>Long Text</option>
                  </select>
                  {errors.customQuestions?.[index]?.type && (
                    <p className='text-danger'>
                      {' '}
                      {errors.customQuestions?.[index]?.type?.message}{' '}
                    </p>
                  )}
                </div>
                <div className='form-input defaultAddress d-flex align-items-center'>
                  <input
                    type='checkbox'
                    className='form-check-input smallCheckBox'
                    {...register(`customQuestions.${index}.required`)}
                  />
                  <span className='ms-2'>Required</span>
                </div>
                <div className='mt-3 add-question text-end'>
                  <button type='button' className='btn' onClick={() => remove(index)}>
                    - Remove
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
        <div className='add-question p-0'>
          <button
            type='button'
            className='btn'
            onClick={() => append({ title: '', type: '', required: false })}
          >
            + Add Question
          </button>
        </div>
      </div>
    </div>
  )
}
